package com.jingfangpai.signSymptom.model

import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import kotlinx.serialization.Serializable

@Serializable
class SignSymptomNames {
    var all:Array<SignSymptomName> = arrayOf()
    var defined:Array<SignSymptomName> = arrayOf()
    var undefined:Array<SignSymptomName> = arrayOf()
}